
export const TranslationDepended = ({ pl = false, en = false, flag, children }) => {
    if (flag === "en" && en)
        return <>{ children }</>;
    
    if (flag === "pl" && pl) 
        return <>{ children }</>;

    return <></>;
}